import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { ApplicationFacade, OpenTripPlannerFacade } from '@ridango/components';
import { BaseComponent } from '@ridango/core';
import { takeUntil } from 'rxjs/operators';
import Env from '@ridango/core/env';
import { ExtendedRoute } from '@ridango/components/lib/open-trip-planner/journey-planner-filter.model';
import { ModalController } from '@ionic/angular';
import { JourneyPlannerRoutesModalComponent } from '../../journey-planner-routes-modal/journey-planner-routes-modal.component';

@Component({
    selector: 'rwidget-journey-planner-filter-route',
    templateUrl: './journey-planner-filter-route.component.html',
    styleUrls: ['./journey-planner-filter-route.component.scss']
})
export class JourneyPlannerFilterRouteComponent extends BaseComponent implements OnInit, OnDestroy {
    @Input() selectedRoutes: string[];
    @Input() showResetButton = !this.env.JOURNEY_PLANNER?.FILTERS?.SHOW_FILTERS_IN_MODAL;
    @Output() filterChanged: EventEmitter<string[]> = new EventEmitter<string[]>();

    routes: ExtendedRoute[];
    routes$ = this.openTripPlannerFacade.routes$;
    allowedRoutes?: ExtendedRoute[];
    updatedRoutes = false;
    assetsPath$ = this.applicationFacade.assetsPath$;

    constructor(
        private openTripPlannerFacade: OpenTripPlannerFacade,
        private applicationFacade: ApplicationFacade,
        private modalCtrl: ModalController,
        @Inject('ENV') public env: Env
    ) {
        super();
    }

    ngOnInit() {
        this.openTripPlannerFacade.getAllRoutes();

        this.routes$.pipe(takeUntil(this.componentDestroyed$)).subscribe((routes) => {
            this.updateRoutesSelection(routes);
        });
    }

    private updateRoutesSelection(routes: ExtendedRoute[]) {
        if (routes) {
            if (this.selectedRoutes?.length) {
                this.routes = routes.map((v) => ({ ...v, selected: this.selectedRoutes.includes(v.id) }));
            } else {
                this.routes = routes.map((v) => ({ ...v, selected: true }));
            }
        }
    }

    public resetAllowedRoutes(): void {
        this.routes = this.routes.map((route) => ({ ...route, selected: true }));
        this.updatedRoutes = false;
        this.allowedRoutes = null;
        this.filterChanged.emit([]);
    }

    public routeColor(route: ExtendedRoute): string {
        if (route.selected) {
            return route.color;
        }
    }

    private setWhitelistedRoutes(): void {
        if (this.areAllRoutesSelected()) {
            this.filterChanged.emit([]);
        } else {
            this.allowedRoutes = this.routes.filter((route) => route.selected);
            this.filterChanged.emit(this.allowedRoutes.map((r) => r.id));
        }
    }

    public areAllRoutesSelected(): boolean {
        return this.routes?.every((route) => route.selected);
    }

    public getSelectedRoutes(): ExtendedRoute[] {
        return this.routes?.filter((route) => route.selected) || [];
    }

    async toggleRoutesModal() {
        const modal = await this.modalCtrl.create({
            component: JourneyPlannerRoutesModalComponent,
            cssClass: 'journey-planner-routes-modal',
            componentProps: {
                routes: this.routes,
                selectedRoutes: this.selectedRoutes
            }
        });

        modal.onDidDismiss().then((result) => {
            if (result.role === 'selected' && result.data) {
                this.routes = result.data;
                this.setWhitelistedRoutes();
            }
        });

        await modal.present();
    }
}
